// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e82d0cd3","453":"279de530","732":"3aa31edc","977":"37d1c24a"}[chunkId] + ".chunk.js";
};